module.exports = __webpack_public_path__ + "static/media/fruits_30.e736e3ce.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_30.csv
// module id = 696
// module chunks = 0